export const sidebarRest = theme => ({})
